import React from 'react';

const SvgWithLabels = ({ company, score }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1165.55 345.25">
    <defs>
      <style>
        {`
          .cls-1 {
            font-family: SFPro-Regular, 'SF Pro';
            font-size: 31px;
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 400;
          }

          .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {
            fill: #fff;
          }

          .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {
            stroke-miterlimit: 10;
          }

          .cls-6, .cls-8, .cls-11, .cls-12 {
            fill: none;
            stroke: #f2f2f2;
          }

          .cls-2 {
            font-family: SFPro-Medium, 'SF Pro';
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 510;
            font-weight: 500;
          }

          .cls-7 {
            fill: #44adff;
          }

          .cls-7, .cls-9, .cls-10, .cls-13 {
            stroke: #fff;
          }

          .cls-7, .cls-9, .cls-14, .cls-13 {
            opacity: .4;
          }

          .cls-8 {
            stroke-dasharray: 4.62 4.62;
          }

          .cls-9 {
            fill: #0994ff;
          }

          .cls-10 {
            fill: #084891;
          }

          .cls-4, .cls-5 {
            font-family: SFPro-Bold, 'SF Pro';
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 700;
            font-weight: 700;
          }

          .cls-5 {
            font-size: 28.71px;
          }

          .cls-11 {
            stroke-dasharray: 4 4;
          }

          .cls-12 {
            stroke-dasharray: 4.02 4.02;
          }

          .cls-13 {
            fill: #007aff;
          }
        `}
      </style>
    </defs>

    {/* Boxes */}
    <rect className="cls-7" x="38.02" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-13" x="311.34" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-9" x="584.66" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-10" x="857.97" y="20.05" width="273.32" height="112.94" />

    {/* Labels */}
    <text className="cls-1" transform="translate(121.8 84.97)">Outpost</text>
    <text className="cls-1" transform="translate(396.68 87.44)">Satellite</text>
    <text className="cls-1" transform="translate(636.57 87.44)">Portfolio Hub</text>
    <text className="cls-1" transform="translate(867.47 87.44)">Transformation Hub</text>

    {/* Line with arrow */}
    <g>
      <line className="cls-6" x1="857.97" y1="171.58" x2="857.97" y2="173.58" />
      <line className="cls-8" x1="857.97" y1="178.2" x2="857.97" y2="194.37" />
      <polyline className="cls-6" points="857.97 196.68 857.97 198.68 859.97 198.68" />
      <line className="cls-12" x1="863.99" y1="198.68" x2="1127.28" y2="198.68" />
      <polyline className="cls-6" points="1129.29 198.68 1131.29 198.68 1131.29 196.68" />
      <line className="cls-8" x1="1131.29" y1="192.06" x2="1131.29" y2="175.89" />
      <line className="cls-6" x1="1131.29" y1="173.58" x2="1131.29" y2="171.58" />
    </g>

    {/* Arrowhead */}
    <line className="cls-11" x1="994.63" y1="227.39" x2="994.63" y2="201.68" />
    <polygon className="cls-3" points="985.96 227.92 994.63 239.48 1003.31 227.92 985.96 227.92" />

    {/* Stage Numbers */}
    <text className="cls-5" transform="translate(30.94 162.07)">1</text>
    <text className="cls-5" transform="translate(302.68 162.07)">2</text>
    <text className="cls-5" transform="translate(575.61 162.07)">3</text>
    <text className="cls-5" transform="translate(848.68 162.07)">4</text>
    <text className="cls-5" transform="translate(1122.32 162.07)">5</text>

    {/* Dynamic Labels */}
    <text class="cls-2" transform="translate(903.77 282.33)">
      <tspan x="70" y="0">{company}</tspan>
    </text>
    <text class="cls-2" transform="translate(950.88 319.19)">
      <tspan x="-10" y="0">Maturity Index: {score}</tspan>
    </text>
  </svg>
);

export default SvgWithLabels;
